import * as React from 'react';

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import useApi from "../../../components/Utils/api";
import { useNavigate } from "react-router-dom";
import { WizardConnector as ColorlibConnector, WizardStepIcon as ColorlibStepIcon } from "components/ui/WizardSteps";
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { StepContent } from "@mui/material";
import MerchantOfficeDetails from "../tabs/merchantOffficeDetails";
import MerchantBankDetails from "../tabs/merchantBankDetails";
import MerchantOtherDetails from "../tabs/merchantOtherDetails";
import { useContext } from "react";
import ValidationContext from "../../../context/validation";
import { merchantSchemaStep1, merchantSchemaStep2, merchantSchemaStep3 } from "../../../models/merchantModel";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import toast from "react-hot-toast";
import {useTranslation} from "react-i18next";
import { useMaterialUIController } from "context";


function NewMerchant() {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const [controller] = useMaterialUIController();
  const { miniSidenav } = controller;

  const api = useApi();
  const [activeStep, setActiveStep] = React.useState(0);
  const { register, handleSubmit, reset, formState: { errors }, trigger, watch, control, setValue } = useForm({
    mode: "onChange",
    defaultValues: { mobileNo: '971' },
    resolver: yupResolver(activeStep === 0 ? merchantSchemaStep1 : activeStep === 1 ? merchantSchemaStep2 : activeStep === 2 ? merchantSchemaStep3 : {})
  });
  const [merchant, setMerchant] = React.useState({ merchantFiles: []});
  const [requiredInfo, setRequiredInfo] = React.useState({
    mcclist : [],
    cityList : [],
    referenceCompany : [],
    microAtm : []
  })

  const onSubmit = data => {
    console.log(activeStep);
    if(activeStep < 2 && Object.keys(errors).length === 0) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      saveMerchant(data);
    }
  };
  const saveMerchant = (data) => {
    let formData = new FormData();

    // Append files
    if (data.supportingDocuments && data.supportingDocuments.length > 0) {
      data.supportingDocuments.forEach((file, index) => {
        for (let i = 0; i < file.length; i++) {
          formData.append('supportingDocuments', file[i]);
        }
      });
    }
    data.merchantBankDetails = data.merchantBankDetails.filter(bankdetails => bankdetails.currency !== ""
        && bankdetails.bankName !== ""
        && bankdetails.bankCode !== ""
        && bankdetails.branch !== ""
        && bankdetails.accountNumber !== "");
    data.merchantBankDetails.forEach(bankdetails => {
      bankdetails.accountNumber = "AE" + bankdetails.accountNumber;
    });
    delete data.supportingDocuments;
    if (data.merchantLogo) {
      formData.append('merchantLogo', data.merchantLogo);
    }
    delete data.merchantLogo;
    // Append MerchantMaster object as a JSON string
    data.mccCode = "1234";
    data.areaCode = "1234";
    // Bank Fee / Commission Fee inputs are hidden from this form; always send a fixed value.
    data.bankFee = "0.0";
    data.issuerFee = "0.0";
    data.tinNo = data.corporateTaxNumber;
    delete data.corporateTaxNumber;
    if (merchant?.merchantGatewayObject?.cardProcessorType != null) {
      data.enabledCardProcessors = merchant.merchantGatewayObject.cardProcessorType;
    }
    if (merchant?.merchantGatewayObject?.enabledWalletTypes != null) {
      data.enabledWalletProcessors = merchant.merchantGatewayObject.enabledWalletTypes;
    }
    data.threeDSecureEnabled = !!merchant?.merchantGatewayObject?.threeDSecureEnabled;
    data.saveCardEnabled = !!merchant?.merchantGatewayObject?.saveCardEnabled;
    data.applePayEnabled = !!merchant?.merchantGatewayObject?.applePayEnabled;
    data.samsungPayEnabled = !!merchant?.merchantGatewayObject?.samsungPayEnabled;
    // Enabled Card Processor, and (when BOTIM with Payment Gateway on) its private/public keys, live in
    // component state rather than react-hook-form, so validate them inline here.
    // Required for new merchants only — editing an existing merchant keeps
    // whatever was already configured.
    if (!data.enabledCardProcessors) {
      toast.error("Enabled Card Processor is required.");
      return;
    }
    const gatewayEnabled = !!merchant?.merchantGatewayObject?.paymentGatewayEnabled;
    data.paymentGatewayEnabled = gatewayEnabled;
    data.posEnabled = !!merchant?.merchantGatewayObject?.posEnabled;
    // Gateway keys are only sent while the gateway is on; otherwise null
    data.botimPrivateKey = null;
    data.botimPublicKey = null;
    if (gatewayEnabled) {
      const botimPrivateKey = merchant?.merchantGatewayObject?.botimPrivateKey?.trim();
      const botimPublicKey = merchant?.merchantGatewayObject?.botimPublicKey?.trim();
      if (data.enabledCardProcessors === "BOTIM" && (!botimPrivateKey || !botimPublicKey)) {
        toast.error("BOTIM requires both the Botim private key and public key (PEM).");
        return;
      }
      data.botimPrivateKey = botimPrivateKey || null;
      data.botimPublicKey = botimPublicKey || null;
    }
    formData.append('merchantMaster', JSON.stringify(data));

    api.post("merchant/create", formData)
      .then(response => {
        if(response.data.statusCodeValue === 200){
          toast.success(response.data.body.message);
          navigate("/merchants/single", {
            state: {
              companyId: response.data.body.companyId
            }
          })
        } else if(response.data.statusCodeValue === 409) {
          toast.error(response.data.body);
        }
        else if(response.data.statusCodeValue === 400) {
          toast.error(response.data.body.message);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
  const handleNext = () => {
    handleSubmit(onSubmit)();
  };
  const formValuesHandler = (e) => {
    const {name, value} = e.target;
    validateInput('NAME_BASED', name, value);
    setMerchant({...merchant, merchant : {...merchant.merchant , [name]: value}});
  }
  const getAllRequiredInfo = () => {
    api.get("merchant/getNewMerchReqInfo")
      .then(response => {
        if(response.data.statusCodeValue === 200){
          setRequiredInfo(response.data.body);
        }
      })
      .catch(error => {

      })
  }
  React.useEffect(() => {
    getAllRequiredInfo();
  }, [])
  const handleBack = () => {
    // console.log(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const steps = [
    {
      label: "OFFICE DETAILS",
      component: <MerchantOfficeDetails merchant={merchant} setMerchant={setMerchant} editmode={true} type="new" errors={errors} register={register}/>
    },
    {
      label: "BANK DETAILS",
      component: <MerchantBankDetails merchant={merchant} setMerchant={setMerchant} editmode={true} type="new"/>
    },
    {
      label: t('other_details'),
      component: <MerchantOtherDetails merchant={merchant} setMerchant={setMerchant} editmode={true} type="new"/>
    }
  ];
  // "OFFICE DETAILS" -> "Office details", for the "Next: <step>" button label
  const toSentenceCase = (label) => label.charAt(0) + label.slice(1).toLowerCase();


  return (
    <DashboardLayout>
      <MDBox mt={3} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12}>
            <MDTypography variant="h5" fontWeight="medium">
              {t('add_merchant')}
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="secondary" mb={3} sx={{ display: "block" }}>
              Step {activeStep + 1} of {steps.length} · {steps[activeStep].label.toLowerCase()}
            </MDTypography>
            <Stack sx={{ width: '100%', maxWidth: "680px" }} spacing={4}>
              <Stepper alternativeLabel style={{ background: 'unset', boxShadow: 'unset' }} activeStep={activeStep} connector={<ColorlibConnector />}>
                {steps.map((step, index) => (
                  <Step key={step.label}>
                    <StepLabel
                      StepIconComponent={ColorlibStepIcon}
                       sx={{
                         '& .MuiStepLabel-label': {
                           color: '#504d4d !important'
                         },
                         '& .MuiStepLabel-label.Mui-active': {
                           color: '#000 !important'
                         },
                         '& .MuiStepLabel-label.Mui-completed': {
                           color: '#000 !important'
                         }
                       }}
                    >
                      {step.label}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Stack>
            <FormProvider {...{ register, handleSubmit, reset, formState: { errors }, trigger, watch, requiredInfo, control, setValue }}>
            {steps.map((step, index) => (
              // pb reserves room so the fixed button bar below never covers the last field
              <Box sx={{ pt: 3, pb: 14 }} key={step.label} style={{ display: activeStep === index ? 'block' : 'none' }}>
                {step.component}
              </Box>
            ))}
            </FormProvider>
          </Grid>
        </Grid>
      </MDBox>
      {/* Fixed to the actual bottom of the viewport (like the sidenav/navbar),
          so it never shifts position between steps or while scrolling. Left
          offset mirrors DashboardLayout's own sidenav-clearing margin. */}
      <Box
        sx={({ breakpoints, functions: { pxToRem } }) => ({
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          // Matches DashboardLayout's own page padding — applied here, outside
          // the 680px budget below, so the fields (which have no padding of
          // their own) and the buttons reach the exact same right edge.
          px: 3,
          [breakpoints.up("xl")]: {
            left: miniSidenav ? pxToRem(96) : pxToRem(250),
          },
        })}
      >
        <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', maxWidth: "680px", pt: 2, pb: 3 }}>
          <MDButton
            variant="outlined"
            color="secondary"
            disabled={activeStep === 0}
            onClick={handleBack}
            sx={{ mr: 1 }}
          >
            {t('back')}
          </MDButton>
          <Box sx={{ flex: '1 1 auto' }} />
          <MDButton variant="gradient" color="info" onClick={handleNext} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {activeStep === steps.length - 1
              ? t('finish')
              : `${t('next')}: ${toSentenceCase(steps[activeStep + 1].label)}`}
            {activeStep !== steps.length - 1 && <ArrowForwardIcon fontSize="small" />}
          </MDButton>
        </Box>
      </Box>
      <Footer />
    </DashboardLayout>
  );
}

export default NewMerchant;
